import request from '../config/axiosConfig';
import { GET_LIST_USERS, GET_USER_INFO, CREATE_USER, UPDATE_USER, DELETE_USER } from '../constants/userApiEndPoint';

export const getUsers = async (params) => {
  return (
    await request({
      url: GET_LIST_USERS,
      method: 'GET',
      params,
    })
  )?.data;
};

export const getUserInfo = async (id) => {
  return (
    await request({
      url: GET_USER_INFO,
      method: 'GET',
      params: { id },
    })
  )?.data;
};

export const createUser = async (data) => {
  return (
    await request({
      url: CREATE_USER,
      method: 'POST',
      data,
    })
  )?.data;
};

export const updateUser = async (id, data) => {
  return (
    await request({
      url: UPDATE_USER,
      method: 'POST',
      params: { id },
      data,
    })
  )?.data;
};

export const deleteUser = async (id) => {
  return (
    await request({
      url: DELETE_USER,
      method: 'DELETE',
      params: { id },
    })
  )?.data;
};
